import { Link } from 'react-router-dom'
import styles from './brand.module.css'

const Brand = () => <Link className={styles.brand} to='/'>rhojn<span>.</span></Link>;

export default Brand;
